import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/assignments';

const model = abstractModel(resource);
const parentGet = model.get;
const parentSave = model.save;
const parentPut = model.put;
const parentDelete = model.remove;

model.get = (params = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { path: resource, filters: queryString });
    }
  }

  return parentGet(params, { path: resource });
};

model.retrieve = (assignmentId) => {
  return parentGet({}, { path: `${resource}/${assignmentId}` });
};

model.save = (data) => {
  return parentSave(data, { path: resource, csrfToken });
};

model.update = (assignmentId, data) => {
  return parentPut(data, { path: `${resource}/${assignmentId}`, csrfToken });
};

model.delete = (assignmentId) => {
  return parentDelete({ id: assignmentId }, { path: resource, csrfToken });
};

export default model;

